import React, { useState, useEffect } from "react";
import { LAY_CHI_TIET_ORDER_SAGA_PUBLIC } from "../../redux/types/OderType";
import { Button, Table } from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";

export default function ChiTietOrder(props) {
  const dispatch = useDispatch();

  const { danhSachDonHangDaChon } = useSelector((state) => state.OrderReducer);

  useEffect(() => {
    dispatch({
      type: LAY_CHI_TIET_ORDER_SAGA_PUBLIC,
      id: props?.match?.params?.id,
    });
  }, []);

  const [showImage, setShowImage] = useState(true);
  const loaiTienTe = danhSachDonHangDaChon[0]?.tbNguonHang?.tbTienTe?.TienTe;
  let tongSoLuong = 0;
  let totalBefore = 0;
  let totalAfter = 0;
  for (let index = 0; index < danhSachDonHangDaChon.length; index++) {
    tongSoLuong += danhSachDonHangDaChon[index]?.SoLuong;
    totalBefore += danhSachDonHangDaChon[index]?.GiaWeb;
    totalAfter +=
      ((100 - danhSachDonHangDaChon[index]?.CodeOff) *
        danhSachDonHangDaChon[index]?.GiaWeb *
        1.0) /
      100;
  }

  totalBefore = totalBefore.toFixed(3);
  totalAfter = totalAfter.toFixed(3);

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return "";

    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(value)
      .replace(/\./g, ",");
  };

  const formatInteger = (value) => {
    if (value === null || value === undefined) return "";

    return new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatDecimal = (value) => {
    if (value === null || value === undefined) return "";

    return new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const columns = [
    {
      title: "STT",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 10,
    },
    {
      title: "Nguồn Hàng",
      dataIndex: "MaDonHang",
      key: "MaDonHang",
      render: (text, record) => (
        <>
          <div>{record?.MaDonHang}</div>
          <div>{record?.TenNguonHang}</div>
          <div>
            Order{": "}
            {record?.IdOrder || record?.tbOrderChiTiet?.[0]?.IdOrder}
          </div>
        </>
      ),
    },
    {
      title: "Ảnh Sản Phẩm",
      key: "LinkAnh",
      render: (text, record) =>
        showImage ? (
          <a target="_blank" href={record?.LinkSanPham} rel="noreferrer">
            <div
              style={{
                width: "90px",
                height: "90px",
                border: "1px solid #d9d9d9",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={record?.LinkAnh}
                alt="Product"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </a>
        ) : null,
    },
    {
      title: "Sản phẩm",
      key: "SanPham",
      align: "left",
      render: (text, record) => (
        <div>
          <div>
            <span style={{ fontWeight: "bold" }}>{record?.TenSanPham}</span>
            {" | "}
            <span style={{ fontWeight: "bold" }}>{record?.MauSanPham}</span>
            {" | "}
            <span style={{ fontWeight: "bold" }}>{record?.Size}</span>
          </div>

          <div>
            <span style={{ fontWeight: "bold" }}>
              {formatDecimal(record?.CanNang)}
            </span>
            {" gam | SL: "}
            <span style={{ fontWeight: "bold" }}>
              {formatInteger(record?.SoLuong)}
            </span>
          </div>

          <div>
            <span style={{ fontWeight: "bold" }}>
              {formatInteger(record?.GiaWeb)}
            </span>{" "}
            {record?.tbNguonHang?.tbTienTe?.TienTe} | CodeOff:{" "}
            <span style={{ fontWeight: "bold" }}>{record?.CodeOff}%</span>
          </div>
        </div>
      ),
    },
    {
      title: "Thanh Toán",
      dataIndex: "GiaBaoVoiKhach",
      key: "GiaBaoVoiKhach",
      width: 150,
      align: "left",
      render: (text, record) => {
        const GiaBaoVoiKhach = parseFloat(record?.GiaBaoVoiKhach).toFixed(1);
        const TienCoc = parseFloat(record?.TienCoc).toFixed(1);
        const TongTienCan = parseFloat(record?.TongTienCan).toFixed(2);
        return (
          <>
            <div>
              Giá:{" "}
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                {formatCurrency(GiaBaoVoiKhach)}
              </span>
            </div>
            <div>
              Cọc:{" "}
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                {formatCurrency(TienCoc)}
              </span>
            </div>
            <div>
              Cân:{" "}
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                {formatCurrency(TongTienCan)}
              </span>
            </div>
            <div>
              Tổng:{" "}
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                {formatCurrency(
                  (parseFloat(record?.GiaBaoVoiKhach) || 0) +
                    (parseFloat(record?.TongTienCan) || 0)
                )}
              </span>
            </div>
          </>
        );
      },
    },
    {
      title: "HTTT|Ngày",
      dataIndex: "NgayHenTraSanPham",
      key: "NgayHenTraSanPham",
      render: (text, record) => {
        const ngayTao = record?.NgayTao
          ? dayjs(record?.NgayTao).format("DD/MM/YYYY")
          : "";
        const ngayHenTraSanPham = record?.NgayHenTraSanPham
          ? dayjs(record?.NgayHenTraSanPham).format("DD/MM/YYYY")
          : "";

        return (
          <>
            <div>
              HTTT:
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                {record?.TenHinhThucThanhToan}
              </span>
            </div>
            <div>
              Lên:{" "}
              <span style={{ fontWeight: "bold" }}>{ngayTao}</span>
            </div>
            <div>
              Hẹn Trả:{" "}
              <span style={{ fontWeight: "bold" }}>{ngayHenTraSanPham}</span>
            </div>
          </>
        );
      },
    },
    {
      title: "Khách Hàng",
      key: "KhachHang",
      render: (text, record) => (
        <div>
          <div>
            {record?.LinkFacebook ? (
              <a target="_blank" href={record?.LinkFacebook} rel="noreferrer">
                <span style={{ fontWeight: "bold" }}>
                  {record?.TenKhachHang}
                </span>
              </a>
            ) : (
              <span style={{ fontWeight: "bold" }}>{record?.TenKhachHang}</span>
            )}
            {" ("}
            <span style={{ fontWeight: "bold" }}>{record?.SoDienThoai}</span>
            {") "}
          </div>
          <div style={{ fontWeight: "bold" }}>{record?.DiaChiNhanHang}</div>
        </div>
      ),
    },
    {
      title: "Tình Trạng Đơn Hàng",
      dataIndex: "TinhTrangDonHang",
      key: "TinhTrangDonHang",
      render: (text, record) => {
        const ngayChuyenTrangThai =
          record?.NgayCapNhatTrangThai || record?.NgayTao;
        return (
          <>
            {record?.IdTinhTrang === 3 ||
            record?.IdTinhTrang === 4 ||
            record?.IdTinhTrang === 8 ||
            record?.IdTinhTrang === 9 ? (
              <span style={{ color: "red", fontWeight: "bold" }}>{text}</span>
            ) : (
              <span>{text}</span>
            )}
            {ngayChuyenTrangThai
              ? `(${dayjs(ngayChuyenTrangThai).format("D/M/YYYY")})`
              : ""}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="container my-5">
        <div className="row">
          <h3 className="col-md-9">
            Chi Tiết Order - {props?.match?.params?.id}
          </h3>
          <div className="col-md-3">
            <Button
              type="primary"
              onClick={() => setShowImage(!showImage)}
              style={{ marginBottom: "20px", backgroundColor: "#36c6d3" }}
            >
              {showImage ? "Ẩn Ảnh" : "Hiện Thị Ảnh"}
            </Button>
          </div>
        </div>
        <Table
          columns={columns}
          rowKey={"Id"}
          dataSource={danhSachDonHangDaChon}
          pagination={false}
        />
      </div>
      <footer
        className="text-center"
        style={{
          height: "30px",
          width: "100%",
          position: "fixed",
          backgroundColor: "#26C281",
          fontSize: 20,
          lineHeight: "25px",
          color: "white",
          bottom: "0",
          zIndex: 1000,
        }}
      >
        Tổng số lượng: <span style={{ fontWeight: "bold" }}>{tongSoLuong}</span>{" "}
        - Trước off: <span style={{ fontWeight: "bold" }}>{totalBefore}</span>{" "}
        {loaiTienTe} - Sau off:{" "}
        <span style={{ fontWeight: "bold" }}>{totalAfter}</span> {loaiTienTe}
      </footer>
    </>
  );
}
